export default "__VITE_ASSET__C$Fhssyl__"